import { useFeedback, useTranslation } from "@opendash/core";
import { Icon } from "@opendash/icons";
import { Upload, UploadFile } from "antd";
import { UploadChangeParam } from "antd/lib/upload";
import React from "react";

type Props = {
  value: UploadFile[];
  disabled?: boolean;
  onChange: (file: UploadFile[]) => void;
};

export default (props: Props) => {
  const t = useTranslation();
  const { message } = useFeedback();

  function uploadHandler(file: UploadFile) {
    if (file.type !== "application/pdf") {
      message.error(
        t(
          "maintenance:knowledge.admin.modal.upload.notifications.upload.FormatError",
          { name: file.name }
        )
      );
      return Upload.LIST_IGNORE;
    }

    if (props.value.some((uploadedFile) => file.name === uploadedFile.name)) {
      message.error(
        t(
          "maintenance:knowledge.admin.modal.upload.notifications.upload.duplicationError",
          { name: file.name }
        )
      );
      return Upload.LIST_IGNORE;
    }
  }

  function changeHandler(info: UploadChangeParam<UploadFile>) {
    info.file.status = "done";
    props.onChange(info.fileList);
  }

  return (
    <Upload.Dragger
      name="file"
      multiple
      fileList={props.value}
      customRequest={() => {}}
      beforeUpload={uploadHandler}
      onChange={changeHandler}
      disabled={props.disabled}
    >
      <Icon icon="fa:upload" size="32" />
      <p className="ant-upload-text">
        {t("maintenance:knowledge.admin.modal.upload.drag.title")}
      </p>
      <p className="ant-upload-hint">
        {t("maintenance:knowledge.admin.modal.upload.drag.description")}
      </p>
    </Upload.Dragger>
  );
};
